import { apiPath, apiUrl } from '../constants';

const getMainObbUploadEndpoint = packageName =>
  `/${apiPath}/apps/${packageName}/obb/upload/`;

const getPatchObbUploadEndpoint = ({ packageName, mainObbId }) =>
  `/${apiPath}/apps/${packageName}/obb/${mainObbId}/upload/`;

export { getMainObbUploadEndpoint, getPatchObbUploadEndpoint };
